import { ChangeDetectorRef, Component, DoCheck, OnInit } from '@angular/core';
import { PersistAlertService } from '../../services/persist-alert.service';
import { CmpPersistAlertObject } from '../../objects/persist-alert.object';

@Component({
    selector: 'cmp-noticebox-persist',
    templateUrl: './noticebox-persist.component.html',
    standalone: false
})
export class NoticeboxPersistComponent implements OnInit, DoCheck {
    public openAlerts: Array<{changed: boolean, alert: CmpPersistAlertObject}> = [];
    
    constructor(
        private alertService: PersistAlertService,
        private cd: ChangeDetectorRef
    ) {
        setInterval(() => {
            this.cd.detectChanges();
        }, 1000);
    }

    ngOnInit() {
        this.openAlerts = this.alertService.getOpenAlerts();
    }

    ngDoCheck() {
        this.openAlerts = this.alertService.getOpenAlerts();
    }

    
}
